import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';
import type { ReceiptDto } from '../types';

export const useReceipt = (receiptId: string) => {
  const { projectId } = useParams();

  return useQuery<ReceiptDto>({
    queryKey: ['receipt', receiptId],
    queryFn: () => apiClient.get(`/v1/projects/${projectId}/receipts/${receiptId}`),
  });
};
